import { SERVICES, STAGE_LABELS, STAGE_STYLE, MEETING_STYLE, label } from "@/lib/constants";
import { Code2, Smartphone, Globe, Megaphone, Cloud, RadioTower } from "lucide-react";

const chip = "inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-[11px] font-medium whitespace-nowrap";
const SERVICE_ICON = { CUSTOM_SOFTWARE: Code2, MOBILE_APP: Smartphone, WEB_APP: Globe, DIGITAL_MARKETING: Megaphone, CLOUD_MANAGED: Cloud, TELECOM_HVAC_IT: RadioTower };

export const StageBadge = ({ stage, testId }) => (
  <span data-testid={testId} className={`${chip} ${STAGE_STYLE[stage] || ""}`}>{STAGE_LABELS[stage] || stage}</span>
);

export const StatusBadge = ({ status }) => (
  <span className={`${chip} border-neutral-300/60 text-neutral-600 bg-neutral-100/50`}>{label(status)}</span>
);

export const MeetingBadge = ({ state, testId }) => (
  <span data-testid={testId} className={`${chip} ${MEETING_STYLE[state] || ""}`}>{label(state)}</span>
);

export const ServiceTag = ({ service }) => {
  const Icon = SERVICE_ICON[service] || Code2;
  return (
    <span className={`${chip} border-neutral-200 bg-white/70 text-neutral-800`}>
      <Icon className="h-3 w-3 text-[#1F9E7A]" />{SERVICES[service] || service}
    </span>
  );
};
